import { createContext, useContext, useState, type ReactNode } from "react";

// Minimal client-side auth state. The real source of truth is always the session cookie
// (checked server-side on every request) — this just avoids re-deriving "am I a manager" etc.
// from scratch on every page within one browser session.
export type CoMemberAuth = { role: "co_member" };
export type MemberAuth = { role: "member"; slug: string; isManager: boolean; takesTest: boolean };
export type AuthState = CoMemberAuth | MemberAuth | null;

const AuthContext = createContext<{
  auth: AuthState;
  setAuth: (auth: AuthState) => void;
} | null>(null);

export function AuthProvider({ children }: { children: ReactNode }) {
  const [auth, setAuth] = useState<AuthState>(null);
  return <AuthContext.Provider value={{ auth, setAuth }}>{children}</AuthContext.Provider>;
}

export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error("useAuth must be used within AuthProvider");
  return ctx;
}
